import { Controller } from '@hotwired/stimulus';

/**
 * Parent GR history: opening a new GR marks it viewed (removes the "new" dot)
 */
export default class extends Controller {
    static values = { url: String };

    async markViewed(event) {
        const item = event.currentTarget;

        if (!item.open || !item.classList.contains('is-new')) {
            return;
        }

        item.classList.remove('is-new');
        item.querySelector('.gr-history__dot')?.remove();

        try {
            const formData = new FormData();
            formData.append('gr_id', item.dataset.grId);

            await fetch(this.urlValue, {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
        } catch (error) {
            console.error('Error marking GR as viewed:', error);
        }
    }
}
